// extracted by mini-css-extract-plugin
module.exports = {"wrap":"pm-z","subtitle":"qm-z","contentWrap":"rm-z","imgWrap":"sm-z","heading":"tm-z","copy":"um-z"};